
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  ValidationProblemDetails,
  Workorder,
  WorkordersApi
} from 'performo-api';
import { User } from 'oidc-client';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    settings: 'settings',
    currentUser: 'currentUser',
    api: 'ordersApi'
  })
})
export default class ApproveDenyComponent extends Vue {
  private api!: WorkordersApi;
  private currentUser!: User;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  get orderReactive() {
    return this.order;
  }

  private validationProblems: ValidationProblemDetails = {};

  private assignTo = '';
  private assignToSecondary = '';
  private jobType = '';
  private trade = '';
  private denyReason = '';

  private approveReqPopoverTippy = false;
  private denyReqPopoverTippy = false;

  async created() {
    // load up order
    this.assignTo =
      this.currentUser.profile.WorkerVendor || this.order.assignTo || '';
    this.jobType = this.order.jobType || '';
    this.trade = this.order.trade || '';
  }

  async approveRequest() {
    //  approve request
    this.api
      .approveOrder({
        workorderApproveCommand: {
          targetAssignTo: this.assignTo,
          targetAssignToSecondary: this.assignToSecondary,
          targetJobType: this.jobType,
          targetTrade: this.trade,
          workorderId: this.order.workorderId
        }
      })
      .then(this.approveSuccessHandler)
      .catch(this.errorHandler);
  }

  private approveSuccessHandler(order: Workorder) {
    this.$emit('request-approved', order);
    this.cancelPopover();
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;
  }

  async denyRequest() {
    this.api
      .denyOrder({
        workorderDenyCommand: {
          workorderId: this.order.workorderId,
          denyReason: this.denyReason
        }
      })
      .then(this.denySuccessHandler)
      .catch(this.errorHandler);
  }

  private denySuccessHandler(order: Workorder) {
    this.$emit('request-denied', order);
    this.cancelPopover();
  }

  cancelPopover() {
    this.approveReqPopoverTippy = false;
    this.denyReqPopoverTippy = false;
    this.validationProblems = [];
  }

  get canApproveDeny() {
    let canApproveDeny = false;
    this.currentUser.profile.candoq.forEach((candoq: string) => {
      if (candoq.startsWith('Approve Orders: Yes')) {
        canApproveDeny = true;
      }
    });
    return canApproveDeny;
  }
}
